import { createSlice } from "@reduxjs/toolkit";

const initialState = {
	fixtures: [],
	selectedMatch: null,
};

const fixturesSlice = createSlice({
	name: "fixtures",
	initialState,
	reducers: {
		setFixtures(state, action) {
			state.fixtures = action.payload;
		},
		setSelectedMatch(state, action) {
			state.selectedMatch = action.payload;
		},
		clearSelectedMatch(state) {
			state.selectedMatch = null;
		},
	},
});

export const { setFixtures, setSelectedMatch, clearSelectedMatch } = fixturesSlice.actions;

export default fixturesSlice.reducer;
